import { MarketplaceDbIntegration } from 'generated/resources/datatable.graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export type BlockingIssue = {
  title: string
  description: string
  buttonLabel?: string
  buttonUrl?: string
}

export const useCompensationsBlockingIssues = (
  validationCodes: string[],
  marketplaceIntegration: MarketplaceDbIntegration | null
): BlockingIssue[] => {
  const { navigation } = useNavigation()
  const integrationSettingsUrl = navigation.discover.marketplace.item.settings.fullPath({
    id: marketplaceIntegration?.datoId ?? '0',
  })

  const compensationsSyncValidations: Record<string, BlockingIssue> = {
    authentication_failed: {
      title: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.authentication_failed.title',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      description: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.authentication_failed.description',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      buttonLabel: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.authentication_failed.button_label'
      ),
      buttonUrl: integrationSettingsUrl,
    },
    missing_all_legal_entity_codes: {
      title: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_legal_entity_codes.title',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      description: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_legal_entity_codes.description'
      ),
      buttonLabel: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_legal_entity_codes.button_label'
      ),
      buttonUrl: integrationSettingsUrl,
    },
    missing_all_payroll_concepts: {
      title: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_payroll_concepts.title',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      description: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_payroll_concepts.description'
      ),
      buttonLabel: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_payroll_concepts.button_label'
      ),
      buttonUrl: integrationSettingsUrl,
    },
    missing_all_employee_codes: {
      title: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_employee_codes.title',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      description: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_employee_codes.description',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      buttonLabel: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_employee_codes.button_label'
      ),
      buttonUrl: navigation.employees.fullPath(),
    },
    missing_all_employee_company_identifier: {
      title: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_employee_company_identifier.title',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      description: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_employee_company_identifier.description',
        {
          integration_name: marketplaceIntegration?.displayName,
        }
      ),
      buttonLabel: i18n.t(
        'compensations.integrations.sync_validations.blocking_issues.missing_all_employee_company_identifier.button_label'
      ),
      buttonUrl: navigation.employees.fullPath(),
    },
  }

  return validationCodes.map((code) => compensationsSyncValidations[code]).filter(Boolean)
}
